import React from "react";
import { ControlledCustomSelect } from "../formsComponents";

export interface IPriorityFilterProps {
  value: string;
  onChange: (value: string) => void;
  isHighlighted?: boolean;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
}

export const ExternalPriorityFilter: React.FC<IPriorityFilterProps> = (
  props,
) => {
  const { value, isHighlighted, onChange, placeholder, disabled, error } = props;

  return (
    <ControlledCustomSelect
      label="Priority"
      labelId="priority"
      fullWidth
      placeholder={placeholder}
      clearable={!!value && !disabled}
      disabled={disabled}
      error={!!error}
      helperText={error || ""}
      sx={{
        minWidth: "90px",
        ...(isHighlighted && {
          backgroundColor: "#fff2c7",
          borderRadius: 1,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "warning.main",
            borderWidth: "2px !important",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "warning.main",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "warning.main",
          },
        }),
      }}
      displayEmpty
      value={value}
      options={[
        { label: "Hot", value: "HOT" },
        { label: "Cold", value: "COLD" },
      ]}
      onChange={(e) => onChange(e.target.value as string)}
      onClear={() => onChange("")}
    />
  );
};

